import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
class UniversalFieldShiftbook extends GenericListTab {
    ConfigurationItem: any;
    IsShowInListVisible: KnockoutObservable<boolean> = ko.observable(true);
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.ConfigurationItem = parent;
        this.ConfigurationItem.UniversalFieldTypeId.subscribe((newValue) => {
            this.SetIsShowInListVisible(newValue);
        });
        this.SetIsShowInListVisible(this.ConfigurationItem.UniversalFieldTypeId());
    }
    ControllerUrl = "UniversalFieldShiftbook";
    SetIsShowInListVisible(universalFieldTypeId: string) {
        if (!Bao.Utils.String.IsNullOrEmpty(universalFieldTypeId)) {
            switch (universalFieldTypeId) {
                case "81c0785b-98b9-45ea-b260-6c6076d5ba3f": // Caption
                case "6f5ad806-d399-4bb5-8417-567041b9ecc6": // Placeholder
                case "80282140-301b-4c8a-8144-e4be45f2de43": // PlaceholderLine
                    this.IsShowInListVisible(false);
                    break;
                default:
                    this.IsShowInListVisible(true);
                    break;
            }
        }
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default UniversalFieldShiftbook;